import {
  InputAddonProps,
  InputGroup,
  InputLeftAddon as InputLeftAddonC,
  InputLeftElement as InputLeftElementC,
  InputProps,
  InputRightAddon as InputRightAddonC,
  InputRightElement as InputRightElementC,
} from '@chakra-ui/react';
import React, { FunctionComponent, ReactNode } from 'react';

type TInputHOC = {
  size?: InputProps['size'];
  variant?: InputProps['variant'];
  children: ReactNode;
  InputLeftElement?: FunctionComponent;
  InputRightElement?: FunctionComponent;
  InputLeftAddon?: string;
  inputLeftAddonSx?: InputAddonProps;
  InputRightAddon?: string;
};

/**
 * HOC like component to tidy up the Input component.
 * If there's InputLeftElement | InputRightElement wrap the input
 * in the InputGroup component.
 */
export default function InputHOC({
  size,
  variant,
  InputLeftElement,
  InputRightElement,
  InputLeftAddon,
  inputLeftAddonSx,
  InputRightAddon,
  children,
}: TInputHOC) {
  if (InputLeftElement || InputRightElement) {
    return (
      <InputGroup variant={variant} size={size}>
        {InputLeftElement && (
          <InputLeftElementC>
            <InputLeftElement />
          </InputLeftElementC>
        )}

        {children}

        {InputRightElement && (
          <InputRightElementC>
            <InputRightElement />
          </InputRightElementC>
        )}
      </InputGroup>
    );
  }

  if (InputLeftAddon || InputRightAddon) {
    return (
      <InputGroup variant={variant} size={size}>
        {InputLeftAddon && (
          <InputLeftAddonC {...inputLeftAddonSx}>
            {InputLeftAddon}
          </InputLeftAddonC>
        )}

        {children}

        {InputRightAddon && (
          <InputRightAddonC>{InputRightAddon}</InputRightAddonC>
        )}
      </InputGroup>
    );
  }

  return <>{children}</>;
}
